export const api = {
    minutesVersionHistoryList: (noteId: string) => `/api/events/minutes/notes/${noteId}/history/`,

    minutesVersionHistoryDetails: (noteId: string, historyId: string) =>
        `/api/events/minutes/notes/${noteId}/history/${historyId}/`
};

export const admin = {
    minutesHistory: (roomSlug: string, filter: string, meetingId: string): string =>
        `/administrator/rooms/${roomSlug}/meetings/${filter}/meeting/${meetingId}/minutes-history/`
};
